<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="9"
        >
          <AutoComplete
            :value="searchBook"
            v-model="searchBook"
            key-value="id"
            key-name="fulltext"
            enable-chips
            enable-clearable
            enable-autofocus
            :items="books"
            :label="$t('fields.book')"
            @search="searchBooks"
            @input="fetchBooksIfExist"
            @clear="deleteSelectedBooks"
            :delay="900"
            :errors="errors"
          >
          </AutoComplete>
        </v-col>

        <v-col
          cols="3"
        >
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:[`item.schools_types_name`]="{ item }">
            {{ item.type.name}} {{ item.type.grouped}}
        </template>

        <template v-slot:[`item.is_primary`]="{ item }">
           <v-icon
            v-if="item.type.schools_types_options && item.type.schools_types_options.is_primary"
           >done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_secondary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options && item.type.schools_types_options.is_secondary"
            >done
            </v-icon><v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_elementary`]="{ item }">
            <v-icon
              v-if="item.type.schools_types_options
              && item.type.schools_types_options.is_elementary"
            >done
            </v-icon>
            <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.city`]="{ item }">
             {{ item.address.city || null}}
        </template>

        <template v-slot:[`item.province`]="{ item }">
             {{ item.address.province_code || null}}
        </template>

        <template v-slot:[`item.code`]="{ item }">
             <span
              v-for="location in item.school_locations_options"
              :key="location.branch_code"
            >
              {{ location.branch_code }}&nbsp;
            </span>
        </template>

      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { booksService } from '../../../utils/services/books.service';
import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportBookSchool',
  components: { AutoComplete, Paginator },
  data() {
      return {
        loading: false,
        searchEditor: null,
        book: {},
        books: [],
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          { text: this.$t('fields.code'), value: 'code', sortable: false },
          { text: this.$t('fields.type'), value: 'schools_types_name' },
          { text: this.$t('fields.school'), value: 'name' },
          { text: this.$t('fields.city'), value: 'city', sortable: false },
          { text: this.$t('fields.province'), value: 'province', sortable: false },
          { text: this.$t('fields.is_elementary'), value: 'is_elementary', sortable: false },
          { text: this.$t('fields.is_primary'), value: 'is_primary', sortable: false },
          { text: this.$t('fields.is_secondary'), value: 'is_secondary', sortable: false },
          { text: this.$t('fields.section'), value: 'counter_section' },
          { text: this.$t('fields.is_new'), value: 'counter_new' },
          { text: this.$t('fields.capociclo'), value: 'counter_capociclo' },
          { text: this.$t('fields.book'), value: 'books.title', sortable: false },
        ],
        filters: {
          bookId: null,
          searchBook: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          bookId: this.filters.bookId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      resetItems() {
        this.items = [];
        this.totalItems = 0;
        this.pagination.page = 1;
      },

      deleteSelectedBooks() {
        this.book = {};
        this.filters.bookId = null;
      },

      async searchBooks(val) {
        this.filters.searchBook = val;
        await this.fetchBooks();
      },

      async fetchBooksIfExist(id) {
        if (id > 0) {
          this.filters.bookId = id;
          await this.fetchBook(id);
        } else {
          this.filters.bookId = 0;
        }
      },

      async fetchBooks() {
        this.loading = true;
        return booksService.index({
          filters: {
            search: this.filters.searchBook,
          },
        })
        .then(response => {
            this.books = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchBook(id) {
        this.loading = true;
        return booksService.get(id)
        .then(response => {
            this.book = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportBookSchool({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchReport();
    },
    watch: {
      'filters.bookId': {
        handler() {
          this.resetItems();
          this.fetchReport();
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchReport(1);
          }
        },
      },
    },
};
</script>
